<template>
  <div class="session-wrapper justify-center justify-md-start">
    <div class="session-left"></div>
    <div class="session-right text-center">
      <div class="session-content">
        <router-link :to="{ name: 'login' }">
          <v-img :src="logotype" class="img-responsive mb-3"/>
        </router-link>

        <h6 class="mb-3">Unknown Device Verification</h6>
        <p class="caption">
          Please enter your E-mail and Password again to verify this request.
        </p>
        <v-form class="mb-4" @submit.prevent>
          <v-container class="pa-0">
            <v-row>
              <v-col cols="12" class="pa-0">
                <v-text-field
                  label="E-mail"
                  outlined
                  v-model.trim="email"
                  data-vv-name="email"
                  data-vv-as="Email"
                  v-validate="'required|email'"
                  :error-messages="errors.collect('email')">
                </v-text-field>
              </v-col>
              <v-col cols="12" class="pa-0">
                <v-text-field
                  label="Password"
                  outlined
                  v-model.trim="password"
                  type="password"
                  data-vv-name="password"
                  data-vv-as="Password"
                  v-validate="'required'"
                  :error-messages="errors.collect('password')">
                </v-text-field>
              </v-col>
              <v-col cols="12" class="pa-0">
                <gg-btn type="submit" block tile dark large color="green" :loading="loading" @click="login">
                  Verify Device
                </gg-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </div>
    </div>
    <cookie-law theme="dark-lime">
      <template slot-scope="props">
        <p>
          This website uses cookies to ensure you get the best experience on our services.
          <a href="https://www.greengeeks.com/legal/privacy" target="_blank">More details</a>
        </p>
        <gg-btn color="primary" tile @click="props.accept">Got it!</gg-btn>
      </template>
    </cookie-law>
  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UnknownDevice',
  components: { CookieLaw },
  props: {
    hash: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      email: '',
      password: '',
      securityToken: '',
    }
  },
  computed: {
    ...mapGetters(['brand']),
    logotype () {
      return this.$vuetify.theme.dark ? this.brand.appLogo : this.brand.darkLogo
    },
  },
  methods: {
    ...mapActions([
      'attemptLogin',
      'reportError',
      'reportSuccess',
    ]),
    async login () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.loading = true
      try {
        await this.attemptLogin({ email: this.email, password: this.password, getparam_emailhash: this.hash })
        this.$router.push({ name: 'dashboard' })
      } catch (e) {
        this.reportError(e)
      }
      this.loading = false
    }
  },
  mounted () {
    const dict = {
      custom: {
        code: {
          regex: 'Input 9 digit recovery code, no leading zero'
        }
      }
    }
    this.$validator.localize('en', dict)
  }
}
</script>
